import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { PICFLOW_STORYBLOK } from '../../picflow-storyblok';

export const storyblokPreventNavInEditModeGuard: CanActivateFn = () => {
  return !inject(PICFLOW_STORYBLOK).storyblokInstance?.isInEditor();
};
